<app-whatsapp-button></app-whatsapp-button>
<div class="container">
  <div class="row justify-content-center">
    <div class="col-10 col-lg-10">
      <h1 [innerHTML]="pageTitle">Atendimento - Pagmob</h1>
      <a class="font-weight-bold" [routerLink]="['/app/servico']">Voltar para a lista de serviços</a>
    </div>
  </div>

  <form-wizard>
    <wizard-step [title]="'Termos e condições'" *ngIf="viewStep('Termos e condições')" [isValid]="form6.form.valid"
      (onPrev)="voltar()" (onNext)="onStep8Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">

            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Termos e condições</h2>
                </div>
              </header>
              <form class="row" name="form" #form6="ngForm">
                <div class="form-group col-lg-12">
                  <label for="disclaimer">Leia os termos abaixo:</label>
                  <textarea class="form-control" id="disclaimer" rows="10" disabled>
                    {{ dadosIniciaisAgendamento.servico.terms }}
                  </textarea>
                </div>
                <div class="form-group col-lg-6">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" #check="ngModel" [(ngModel)]="model.termos" name="termos"
                      type="checkbox" value="" id="termos" required>
                    <label for="termos" class="form-check-label">{{ dadosIniciaisAgendamento.servico.termsConfirmation
                      }}*</label>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- termos e condições -->

    <wizard-step [title]="'Informações Gerais'" *ngIf="!!dadosIniciaisAgendamento.servico.information" [isValid]="true"
      (onPrev)="voltar()" (onNext)="onStep1Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">

            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Informações gerais</h2>
                </div>
              </header>

              <div>
                <p class="formated-text" [innerHTML]="link(dadosIniciaisAgendamento.servico.information)"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- informações gerais -->

    <wizard-step [title]="'Solicitante'" *ngIf="viewStep('Solicitante')" [isValid]="formSolic.form.valid"
      (onPrev)="voltar()" (onNext)="onStep12Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">
            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Solicitante</h2>
                  <h3>Selecione a quem se destina o serviço.</h3>
                </div>
              </header>

              <div class="form-content">
                <form class="row" id="formSolic" name="formSolic" #formSolic="ngForm">
                  <div class="form-group col-lg-12">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" name="requirer" type="radio" value="M"
                        [(ngModel)]="model.requirerType" checked name="gender-radio" id="myself">
                      <label class="form-check-label" for="myself">Titular</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" name="requirer" type="radio" value="T"
                        [(ngModel)]="model.requirerType" name="gender-radio" id="third">
                      <label class="form-check-label" for="third">Para Terceiro</label>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- descrição da solicitação -->

    <wizard-step [title]="'Descrição da solicitação'" *ngIf="viewStep('Descrição da solicitação')"
      [isValid]="formdesc.form.valid" (onPrev)="voltar()" (onNext)="onStep1Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">
            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Descrição da solicitação</h2>
                  <h3>Descreva o motivo da solicitação.</h3>
                </div>
              </header>

              <div class="form-content">
                <form class="row" id="formDesc" name="formDesc" #formdesc="ngForm">
                  <div class="form-group col-lg-12"
                    [ngClass]="{ 'invalid': customerDescription.invalid && customerDescription.touched }">
                    <label>*</label>
                    <textarea #customerDescription="ngModel" class="form-control" id="customerDescription"
                      name="customerDescription" [(ngModel)]="model.customerDescription" placeholder="" rows="4"
                      maxlength="1500" required></textarea>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- descrição da solicitação -->

    <wizard-step [title]="'Informações pessoais'" *ngIf="viewStep('Informações pessoais')"
      [isValid]="form1.form.valid && personalInfoValid()" (onPrev)="voltar()" (onNext)="onStep1Next($event)">
      <div class="container">

        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">

            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. <span *ngIf="!model.requirerType || model.requirerType == 'M'">Informações
                      pessoais</span><span *ngIf="model.requirerType == 'T'">Informações do Terceiro</span></h2>
                  <h3><span *ngIf="model.requirerType == 'M'">Você pode atualizar os dados, caso necessário.</span></h3>
                </div>
              </header>

              <div class="form-content">
                <form class="row" id="formInfPessoal" name="formInfPessoal" #form1="ngForm">
                  <div class="form-group col-lg-6" [ngClass]="{ 'invalid': fullName.invalid && fullName.touched }">
                    <label>Nome completo*</label>
                    <input type="text" #fullName="ngModel" class="form-control" id="fullName" name="fullName"
                      [disabled]="disableField('PERSONAL_DATA', 'nome')" [(ngModel)]="model.userData.fullName"
                      pattern=".*[^ ].*" required>
                    <div *ngIf="fullName.errors && fullName.invalid && fullName.dirty">
                      <small class="text-danger" *ngIf="fullName.errors.required">O nome deve ser informado</small>
                      <small class="text-danger" *ngIf="fullName.errors.pattern">O nome não pode ser somente espaço em
                        branco</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6" [ngClass]="{ 'invalid': socialName.invalid && socialName.touched }">
                    <label>Nome Social</label>
                    <input type="text" #socialName="ngModel" class="form-control" id="socialName" name="socialName"
                      (blur)="habilitarCheckBox()" [disabled]="disableField('PERSONAL_DATA', 'socialName')"
                      [(ngModel)]="model.userData.socialName" pattern=".*[^ ].*">
                    <div *ngIf="socialName.errors && socialName.invalid && socialName.dirty">
                      <small class="text-danger" *ngIf="socialName.errors.pattern">O nome social não pode ser somente
                        espaço em branco</small>
                    </div>
                  </div>

                  <div *ngIf="mostrarCheckbox" style="margin-left: 480px; margin-bottom: 20px;" class="row">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" id="requireSocialName" name="requireSocialName"
                        [(ngModel)]="model.requireSocialName" (change)="handleSocialNameChange()">
                      <label class="form-check-label" for="requireSocialName">
                        Solicito a impressão do meu Nome Social no Bilhete único.
                      </label>
                    </div>
                  </div>

                  <div class="form-group col-lg-6"
                    [ngClass]="{ 'invalid': motherFullName.invalid && motherFullName.touched }">
                    <label>Nome da mãe*</label>
                    <input type="text" #motherFullName="ngModel" class="form-control" id="motherFullName"
                      name="motherFullName" [disabled]="disableField('PERSONAL_DATA', 'nomeMae')"
                      [(ngModel)]="model.userData.motherFullName" pattern=".*[^ ].*" required>
                    <div *ngIf="motherFullName.errors && motherFullName.invalid && motherFullName.dirty">
                      <small class="text-danger" *ngIf="motherFullName.errors.required">O nome da mãe deve ser
                        informado</small>
                      <small class="text-danger" *ngIf="motherFullName.errors.pattern">O nome da mãe não pode ser
                        somente espaço em branco</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6"
                    [ngClass]="{ 'invalid': fatherFullName.invalid && fatherFullName.touched }">
                    <label>Nome do pai</label>
                    <input type="text" #fatherFullName="ngModel" class="form-control" id="fatherFullName"
                      name="fatherFullName" [disabled]="disableField('PERSONAL_DATA', 'nomePai')"
                      [(ngModel)]="model.userData.fatherFullName" placeholder="">
                  </div>

                  <div class="form-group col-lg-6" [ngClass]="{ 'invalid': email.invalid && email.touched }">
                    <label>E-mail*</label>
                    <input type="email" #email="ngModel" class="form-control" id="email" name="email"
                      [disabled]="disableField('PERSONAL_DATA', 'email')" [(ngModel)]="model.userData.email"
                      placeholder="email@exemplo.com.br" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required
                      email>
                    <div *ngIf="email.errors && email.invalid && email.dirty">
                      <small class="text-danger" *ngIf="email.errors.required">E-mail deve ser informado</small>
                      <small class="text-danger" *ngIf="email.errors.pattern">Informe um email válido</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cpf.invalid && cpf.touched }">
                    <label>CPF*</label>
                    <input type="text" #cpf="ngModel" class="form-control" id="cpf" name="cpf"
                      [disabled]="disableField('PERSONAL_DATA', 'cpf')" [(ngModel)]="model.userData.cpf"
                      [textMask]="{mask: cpfmask}" placeholder="___.___.___-__" (ngModelChange)="isCpfValid($event)"
                      required>
                    <div *ngIf="cpf.errors && cpf.invalid && cpf.dirty">
                      <small class="text-danger" *ngIf="cpf.errors.incorrect">Informe um CPF válido</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6"
                    [ngClass]="{ 'invalid': phoneNumber.invalid && phoneNumber.touched }">
                    <label>Telefone*</label>
                    <input type="text" #phoneNumber="ngModel" class="form-control" id="phoneNumber" name="phoneNumber"
                      [disabled]="disableField('PERSONAL_DATA', 'telefone')" [(ngModel)]="model.userData.phoneNumber"
                      [textMask]="{mask: telefonemask}" placeholder="(__) _____-____" required>
                  </div>

                  <div class="form-group"
                    [ngClass]="{ 'invalid': rg.invalid && rg.touched, 'col-lg-6': (!disableField('PERSONAL_DATA', 'rg') && !hasExternalAPI()), 'col-lg-3': hasExternalAPI() }">
                    <label>RG (com dígito){{model.abtServiceTypeId == 1 ? "*" : ""}}</label>
                    <input type="text" #rg="ngModel" class="form-control" id="rg" name="rg"
                      [disabled]="disableField('PERSONAL_DATA', 'rg')" [(ngModel)]="model.userData.rg" maxlength="16"
                      [required]="model.abtServiceTypeId == 1">
                  </div>

                  <div class="form-group col-lg-3" [ngClass]="{ 'invalid': rgEmission.invalid && rgEmission.touched }"
                    *ngIf="hasExternalAPI()">
                    <label>Data de Emissão*</label>
                    <input type="text" #rgEmission="ngModel" class="form-control" id="rgEmission" name="rgEmission"
                      (ngModelChange)="alterarEmissao($event)" [disabled]="disableField('PERSONAL_DATA', 'rg')"
                      [(ngModel)]="model.userData.rgEmissionString" [textMask]="{mask: datamask}"
                      placeholder="__/__/____" required>
                    <div *ngIf="rgEmission.invalid && rgEmission.dirty">
                      <small class="text-danger">Informe a data no formato dd/mm/aaaa</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-3" [ngClass]="{ 'invalid': rgState.invalid && rgState.touched }"
                    *ngIf="hasExternalAPI()">
                    <label for="rgState">Estado de emissão*</label>
                    <select class="js-example-basic-single form-control" #rgState="ngModel"
                      [disabled]="disableField('PERSONAL_DATA', 'rg')" [(ngModel)]="model.userData.rgState" id="rgState"
                      name="rgState" required>
                      <option *ngFor="let e of estados" [value]="e.value">{{e.name}}</option>
                    </select>
                  </div>

                  <div class="form-group col-lg-3" [ngClass]="{ 'invalid': rgAuthority.invalid && rgAuthority.touched }"
                    *ngIf="hasExternalAPI()">
                    <label for="rgAuthority">Órgão de emissão*</label>
                    <select class="js-example-basic-single form-control" #rgAuthority="ngModel"
                      [disabled]="disableField('PERSONAL_DATA', 'rg')" [(ngModel)]="model.userData.rgAuthority"
                      id="rgAuthority" name="rgAuthority" required>
                      <option value="SSP">SSP</option>
                      <option value="DPF">DPF</option>
                      <option value="MAER">MAER</option>
                      <option value="MINEX">MINEX</option>
                      <option value="OUTROS">OUTROS</option>
                    </select>
                  </div>

                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.requireMobileNumber">
                    <label>Telefone celular</label>
                    <input type="text" #telefoneCelular="ngModel" class="form-control" id="telefoneCelular"
                      name="telefoneCelular" [disabled]="disableField('PERSONAL_DATA', 'telefoneCelular')"
                      [(ngModel)]="model.userData.telefoneCelular" [textMask]="{mask: telefonemask}"
                      placeholder="(__) _____-____">
                  </div>

                  <div class="form-group col-lg-6" [ngClass]="{ 'invalid': birthDate.invalid && birthDate.touched }">
                    <label>Data de Nascimento*</label>
                    <input type="text" #birthDate="ngModel" class="form-control" id="birthDate" name="birthDate"
                      (ngModelChange)="alterarData($event)" [disabled]="disableField('PERSONAL_DATA', 'birthDate')"
                      [(ngModel)]="model.userData.birthDate2" [textMask]="{mask: datamask}" placeholder="__/__/____"
                      required>
                    <div *ngIf="birthDate.invalid && birthDate.dirty">
                      <small class="text-danger">Informe uma data de nascimento válida no formato dd/mm/aaaa</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.requireCardNumber">
                    <label>Nº Bilhete Transporte</label>
                    <input type="text" #transportCardNumber="ngModel" class="form-control" id="transportCardNumber"
                      name="transportCardNumber" [disabled]="disableField('PERSONAL_DATA', 'numeroCartao')"
                      [(ngModel)]="model.transportCardNumber">
                  </div>

                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.requireNationality">
                    <label for="nacionalidade">Nacionalidade*</label>
                    <select class="js-example-basic-single form-control" #nacionalidade="ngModel"
                      [disabled]="disableField('PERSONAL_DATA', 'nacionalidade')"
                      [(ngModel)]="model.userData.nacionalidade" id="nacionalidade" name="nacionalidade" required>
                      <option *ngFor="let nac of nacionalidades" [value]="nac">{{nac}}</option>
                    </select>
                  </div>

                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.requireMaritalStatus">
                    <label for="maritalStatus">Estado Civil*</label>
                    <select class="js-example-basic-single form-control" #maritalStatus="ngModel"
                      [disabled]="disableField('PERSONAL_DATA', 'estadoCivil')" [(ngModel)]="model.userData.estadoCivil"
                      id="maritalStatus" name="maritalStatus" required>
                      <option value="Solteiro(a)">Solteiro(a)</option>
                      <option value="Casado(a)">Casado(a)</option>
                      <option value="Divorciado(a)">Divorciado(a)</option>
                      <option value="Viúvo(a)">Viúvo(a)</option>
                    </select>
                  </div>

                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.requireFamilyIncome">
                    <label>Renda Familiar</label>
                    <input type="number" min="0" step="1" max="2147483647" (ngModelChange)="alterarRenda($event)"
                      #income="ngModel" class="form-control" id="income" name="income"
                      [disabled]="disableField('PERSONAL_DATA', 'income')" [(ngModel)]="model.userData.income"
                      placeholder="R$ _____" (error)="true">
                    <div *ngIf="income.invalid && income.dirty">
                      <small class="text-danger">Insira apenas números</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.requireResponsavel">
                    <label>Responsável<span *ngIf="menor()">*</span></label>
                    <input type="text" #responsavel="ngModel" class="form-control" id="responsavel" name="responsavel"
                      [disabled]="disableField('PERSONAL_DATA', 'responsavel')" [(ngModel)]="model.userData.responsavel"
                      [required]="menor()">
                  </div>

                  <div class="form-group">
                    <label>Sexo</label>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" name="gender" type="radio" value="F"
                        [disabled]="disableField('PERSONAL_DATA', 'sexo')" [(ngModel)]="model.userData.gender" checked
                        name="gender-radio" id="female">
                      <label class="form-check-label" for="female">Feminino</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" name="gender" type="radio" value="M"
                        [disabled]="disableField('PERSONAL_DATA', 'sexo')" [(ngModel)]="model.userData.gender"
                        name="gender-radio" id="male">
                      <label class="form-check-label" for="male">Masculino</label>
                    </div>
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" name="gender" type="radio" value="X"
                        [disabled]="disableField('PERSONAL_DATA', 'sexo')" [(ngModel)]="model.userData.gender" checked
                        name="gender-radio" id="no">
                      <label class="form-check-label" for="no">Não informado</label>
                    </div>
                    <div class="form-check form-check-inline"
                      *ngIf="model.userData.gender == undefined || (model.userData.gender.length <=1 && model.userData.gender != ' ')">
                      <input class="form-check-input" name="gender" type="radio" value=" "
                        [disabled]="disableField('PERSONAL_DATA', 'sexo')" [(ngModel)]="model.userData.gender"
                        name="gender-radio" id="personalization" maxlength="24">
                      <label class="form-check-label" for="personalization">Personalizado</label>
                    </div>
                    <div class="form-check form-check-inline"
                      *ngIf="model.userData.gender != undefined && (model.userData.gender.length > 1 || model.userData.gender == ' ')">
                      <label class="form-check-label mr-1" for="customgender">Personalizado</label>
                      <input type="text" class="form-control" name="gender"
                        [disabled]="!(model.userData.gender.length > 1 || model.userData.gender == ' ')"
                        [(ngModel)]="model.userData.gender" id="customgender" [required]="model.userData.gender == ' '">
                    </div>
                  </div>
                </form>
                <div class="bg-warning text-dark p-3 mb-2" *ngIf="!personalInfoValid()"><img
                    src="assets/icons/error.svg" alt="Erro"> {{personalInfoErrorMsg()}}</div>
              </div>
            </div>

          </div>
        </div>

      </div>
    </wizard-step><!-- Informações pessoais -->

    <wizard-step [title]="'Dados da Empresa'" *ngIf="viewStep('Dados da Empresa')" [isValid]="form2.form.valid"
      (onPrev)="voltar()" (onNext)="onStep1Next($event)">
      <div class="container">

        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">

            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. <span *ngIf="!model.requirerType || model.requirerType == 'M'">Dados da
                      Empresa</span><span *ngIf="model.requirerType == 'T'">Informações do Terceiro</span></h2>
                  <h3><span *ngIf="model.requirerType == 'M'">Você pode atualizar os dados, caso necessário.</span></h3>
                </div>
              </header>

              <div class="form-content">
                <form class="row" id="formEmpresa" name="formEmpresa" #form2="ngForm">
                  <div class="form-group col-lg-6" [ngClass]="{ 'invalid': fullName.invalid && fullName.touched }">
                    <label>Razão Social*</label>
                    <input type="text" #fullName="ngModel" class="form-control" id="fullName" name="fullName"
                      [disabled]="disableField('PERSONAL_DATA', 'nome')" [(ngModel)]="model.userData.fullName"
                      pattern=".*[^ ].*" required>
                    <div *ngIf="fullName.errors && fullName.invalid && fullName.dirty">
                      <small class="text-danger" *ngIf="fullName.errors.required">A razão social deve ser
                        informado</small>
                      <small class="text-danger" *ngIf="fullName.errors.pattern">O razão social não pode ser somente
                        espaço em branco</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cpf.invalid && cpf.touched }">
                    <label>CNPJ*</label>
                    <input type="text" class="form-control" id="cnpj" name="cnpj"
                      [disabled]="disableField('PERSONAL_DATA', 'cpf')" [(ngModel)]="model.userData.cpf" #cpf="ngModel"
                      [textMask]="{mask: cnpjmask}" placeholder="__.___.___/____-__"
                      (ngModelChange)="isCnpjValid($event)" required>
                    <div *ngIf="cpf.errors && cpf.invalid && cpf.dirty">
                      <small class="text-danger" *ngIf="cpf.errors.incorrect">Informe um CNPJ válido</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6" [ngClass]="{ 'invalid': email.invalid && email.touched }">
                    <label>E-mail*</label>
                    <input type="email" #email="ngModel" class="form-control" id="email" name="email"
                      [disabled]="disableField('PERSONAL_DATA', 'email')" [(ngModel)]="model.userData.email"
                      placeholder="email@exemplo.com.br" pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" required
                      email>
                    <div *ngIf="email.errors && email.invalid && email.dirty">
                      <small class="text-danger" *ngIf="email.errors.required">E-mail deve ser informado</small>
                      <small class="text-danger" *ngIf="email.errors.pattern">Informe um email válido</small>
                    </div>
                  </div>

                  <div class="form-group col-lg-6"
                    [ngClass]="{ 'invalid': phoneNumber.invalid && phoneNumber.touched }">
                    <label>Telefone*</label>
                    <input type="text" #phoneNumber="ngModel" class="form-control" id="phoneNumber" name="phoneNumber"
                      [disabled]="disableField('PERSONAL_DATA', 'telefone')" [(ngModel)]="model.userData.phoneNumber"
                      [textMask]="{mask: telefonemask}" placeholder="(__) _____-____" required>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- Dados da Empresa -->

    <wizard-step [title]="'Endereço'" *ngIf="viewStep('Endereço')" [isValid]="form2.form.valid" (onPrev)="voltar()"
      (onNext)="onStep2Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">
            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Endereço</h2>
                </div>
              </header>

              <form class="row" name="form" #form2="ngForm">

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cep.invalid && cep.touched }">
                  <label>CEP*</label>
                  <input type="text" #cep="ngModel" class="form-control" id="cep" name="cep"
                    [disabled]="disableField('ADDRESS_DATA', 'cep')" [(ngModel)]="model.userData.cep"
                    [textMask]="{mask: cepmask}" (blur)="consultaCEP(cep.value, model.userData)" placeholder="_____-___"
                    required>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': address.invalid && address.touched }">
                  <label>Nome da rua*</label>
                  <input type="text" #address="ngModel" class="form-control" id="address" name="address"
                    [disabled]="disableField('ADDRESS_DATA', 'endereco')" [(ngModel)]="model.userData.address"
                    placeholder="" required>
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': addressNumber.invalid && addressNumber.touched }">
                  <label>Número*</label>
                  <input type="text" #addressNumber="ngModel" class="form-control" id="addressNumber"
                    name="addressNumber" [disabled]="disableField('ADDRESS_DATA', 'numero')"
                    [(ngModel)]="model.userData.addressNumber" placeholder="" required>
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': addressComplement.invalid && addressComplement.touched }">
                  <label>Complemento</label>
                  <input type="text" #addressComplement="ngModel" class="form-control" id="addressComplement"
                    name="addressComplement" [disabled]="disableField('ADDRESS_DATA', 'complemento')"
                    [(ngModel)]="model.userData.addressComplement" placeholder="">
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': neighborhood.invalid && neighborhood.touched }">
                  <label>Bairro*</label>
                  <input type="text" #neighborhood="ngModel" class="form-control" id="neighborhood" name="neighborhood"
                    [disabled]="disableField('ADDRESS_DATA', 'bairro')" [(ngModel)]="model.userData.neighborhood"
                    placeholder="" required>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': state.invalid && state.touched }">
                  <label>Estado*</label>

                  <select class="js-example-basic-single form-control" #state="ngModel"
                    [(ngModel)]="model.userData.state" id="state" name="state"
                    (ngModelChange)="atualizarCidades($event)" [disabled]="disableField('ADDRESS_DATA', 'estado')"
                    required>
                    <option value="AC">Acre (AC)</option>
                    <option value="AL">Alagoas (AL)</option>
                    <option value="AP">Amapá (AP)</option>
                    <option value="AM">Amazonas (AM)</option>
                    <option value="BA">Bahia (BA)</option>
                    <option value="CE">Ceará (CE)</option>
                    <option value="DF">Distrito Federal (DF)</option>
                    <option value="ES">Espírito Santo (ES)</option>
                    <option value="GO">Goiás (GO)</option>
                    <option value="MA">Maranhão (MA)</option>
                    <option value="MT">Mato Grosso (MT)</option>
                    <option value="MS">Mato Grosso do Sul (MS)</option>
                    <option value="MG">Minas Gerais (MG)</option>
                    <option value="PA">Pará (PA)</option>
                    <option value="PB">Paraíba (PB)</option>
                    <option value="PR">Paraná (PR)</option>
                    <option value="PE">Pernambuco (PE)</option>
                    <option value="PI">Piauí (PI)</option>
                    <option value="RJ">Rio de Janeiro (RJ)</option>
                    <option value="RN">Rio Grande do Norte (RN)</option>
                    <option value="RS">Rio Grande do Sul (RS)</option>
                    <option value="RO">Rondônia (RO)</option>
                    <option value="RR">Roraima (RR)</option>
                    <option value="SC">Santa Catarina (SC)</option>
                    <option value="SP">São Paulo (SP)</option>
                    <option value="SE">Sergipe (SE)</option>
                    <option value="TO">Tocantins (TO)</option>
                  </select>
                </div>

                <div class="form-group col-lg-6">
                  <label>Cidade</label>
                  <select class="js-example-basic-single form-control"
                    [disabled]="disableField('ADDRESS_DATA', 'cidade')" #city="ngModel" name="city"
                    [(ngModel)]="model.userData.city">
                    <option *ngFor="let d of cidades" [value]="d.nome" [selected]="d.nome === model.userData.city">
                      {{d.nome}}
                    </option>
                  </select>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </wizard-step><!--Endereço -->

    <wizard-step [title]="'Instituição de ensino'" *ngIf="viewStep('Instituição de ensino')"
      [isValid]="model.institutionData.institutionId" (onPrev)="voltar()" (onNext)="onStep3Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">
            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Instituição de ensino</h2>
                </div>
              </header>

              <div class="form-content">
                <form>

                  <div class="form-group">
                    <label for="institution">Instituição</label>

                    <div class="input-group mb-3">
                      <input type="text" [(ngModel)]="search" class="form-control" id="institution" name="institution"
                        placeholder="Pesquisar instituição" aria-label="Pesquisar instituição"
                        aria-describedby="basic-addon2">
                      <div class="input-group-append">
                        <button id="lupa" class="btn btn-primary" type="button" (click)="getInstituicaoEnsino()"
                          data-toggle="modal" data-target="#result" [disabled]="!search"><img
                            src="assets/icons/lupa.svg" alt="Pesquisar"></button>
                      </div>
                    </div>
                    <div *ngIf="model.institutionData.institutionId" class="mt-3">
                      <label for="institution">Instituição Selecionada</label>
                      <ul class="option-list">
                        <li class="col-12">
                          <h4>{{ model.institutionData.name }}</h4>
                          <p class="caption">{{ model.institutionData.address }}</p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <div class="modal fade" id="result" tabindex="-1" role="dialog" aria-labelledby="result-lLabel"
              aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd"
                          d="M8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8C16 9.84871 15.3729 11.551 14.3199 12.9056L19.7071 18.2929L18.2929 19.7071L12.9057 14.3199C11.551 15.3729 9.84871 16 8 16ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
                          fill="#4B4B4B" />
                      </svg>
                      Resultado
                    </h2>
                    <button type="button" class="close" id="fecharModal" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <ul class="option-list">
                      <li *ngFor="let instituicao of instituicoes" (click)="selecionaInstituicaoEnsino(instituicao)"
                        style="cursor: pointer;">
                        <h4>{{ instituicao.name }}</h4>
                        <p class="caption">{{ instituicao.address }}</p>
                      </li>
                    </ul>
                    <div *ngIf="!instituicoes || instituicoes.length < 1">Não encontrado.</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </wizard-step><!-- instituição de ensino  -->

    <wizard-step [title]="'Curso'" *ngIf="viewStep('Curso')" [isValid]="form3.form.valid" (onPrev)="voltar()"
      (onNext)="onStep4Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">
            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Curso</h2>
                </div>
              </header>

              <form class="row" name="form" #form3="ngForm">
                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': institutionCourseType.invalid && institutionCourseType.touched }">
                  <label>Tipo de Curso*</label>

                  <select class="js-example-basic-single form-control" #institutionCourseType="ngModel"
                    [disabled]="disableField('INSTITUTION_DATA', 'institutionCourseType')"
                    [(ngModel)]="model.institutionData.institutionCourseType" id="institutionCourseType"
                    name="institutionCourseType" required>
                    <option value="Educação Infantil">Educação Infantil</option>
                    <option value="Ensino Fundamental">Ensino Fundamental</option>
                    <option value="Ensino Médio">Ensino Médio</option>
                    <option value="Técnico">Técnico</option>
                    <option value="Ensino Superior">Ensino Superior</option>
                    <option value="Pós Graduação">Pós Graduação</option>
                    <option value="Mestrado">Mestrado</option>
                    <option value="Doutorado">Doutorado</option>
                    <option value="Professor de Escola Pública">Professor de Escola Pública</option>
                  </select>
                </div>

                <div class="form-group col-lg-6">
                  <label>Período</label>
                  <select class="js-example-basic-single form-control" #institutionCoursePeriod="ngModel"
                    [disabled]="disableField('INSTITUTION_DATA', 'institutionCoursePeriod')"
                    [(ngModel)]="model.institutionData.institutionCoursePeriod" id="institutionCoursePeriod"
                    name="institutionCoursePeriod">
                    <option value="Manhã">Manhã</option>
                    <option value="Tarde">Tarde</option>
                    <option value="Noite">Noite</option>
                    <option value="Integral">Integral</option>
                  </select>
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': institutionCourseName.invalid && institutionCourseName.touched }">
                  <label>Nome do curso</label>
                  <input type="text" #institutionCourseName="ngModel" class="form-control" id="institutionCourseName"
                    name="institutionCourseName" [disabled]="disableField('INSTITUTION_DATA', 'institutionCourseName')"
                    [(ngModel)]="model.institutionData.institutionCourseName">
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': institutionEnrollmentId.invalid && institutionEnrollmentId.touched }">
                  <label>Matrícula</label>
                  <input type="text" #institutionEnrollmentId="ngModel" class="form-control"
                    id="institutionEnrollmentId" name="institutionEnrollmentId"
                    [disabled]="disableField('INSTITUTION_DATA', 'institutionEnrollmentId')"
                    [(ngModel)]="model.institutionData.institutionEnrollmentId">
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': institutionCourseYear.invalid && institutionCourseYear.touched }">
                  <label>Semestre</label>
                  <input type="text" #institutionCourseYear="ngModel" class="form-control" id="institutionCourseYear"
                    name="institutionCourseYear" [disabled]="disableField('INSTITUTION_DATA', 'institutionCourseYear')"
                    [(ngModel)]="model.institutionData.institutionCourseYear">
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': institutionCourseDuration.invalid && institutionCourseDuration.touched }">
                  <label>Duração</label>
                  <input type="text" #institutionCourseDuration="ngModel" class="form-control"
                    id="institutionCourseDuration" name="institutionCourseDuration"
                    [disabled]="disableField('INSTITUTION_DATA', 'institutionCourseDuration')"
                    [(ngModel)]="model.institutionData.institutionCourseDuration">
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'has-error': institutionCourseEndYear.invalid && institutionCourseEndYear.touched }">
                  <label for="institutionCourseEndYear">Ano de Conclusão*</label>
                  <input id="institutionCourseEndYear" type="text" #institutionCourseEndYear="ngModel" class="form-control"
                    id="institutionCourseEndYear" name="institutionCourseEndYear"
                    [disabled]="disableField('INSTITUTION_DATA', 'institutionCourseEndYear')"
                    [(ngModel)]="model.institutionData.institutionCourseEndYear" placeholder="XXXX" pattern="[0-9]{4}"
                    required (change)="validateYear(model.institutionData.institutionCourseEndYear)">
                  <span *ngIf="invalidYear"
                    class="text-danger">
                    O ano de conclusão não pode ser menor que o ano atual.
                  </span>
                </div>
              </form>

            </div>

          </div>
        </div>
      </div>
    </wizard-step><!-- curso -->

    <wizard-step [title]="'Documentos'" *ngIf="viewStep('Documentos')" [isValid]="allRequiredDocsSent"
      (onPrev)="voltar()" (onNext)="onStep5Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">
            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Documentos</h2>
                  <p>Para prosseguir, é necessário enviar foto(s) do(s) seguinte(s) documento(s):</p><br>
                </div>
              </header>

              <div class="row">

                <div class="col-lg-6" *ngFor="let documento of dadosIniciaisAgendamento.servico.requiredDocs">
                  <div class="document" [ng2-loading]="showSpinner">
                    <p>{{ documento.name }}</p>
                    <p><strong>{{ documento.description }}</strong></p>
                    <img *ngIf="documento.imageExample" [src]="'data:image/jpg;base64,'+documento.imageExample"
                      [ngClass]="{'full-width': !fileInputFilled, 'small-width': fileInputFilled}"
                      style="margin-bottom: 10px;">
                    <div id="imageFormGroup" class="form-group">
                      <input type="file" id="file" (change)="enviarArquivos($event, documento)"
                        accept="application/pdf, .pdf, image/png, .png, image/jpeg, .jpg, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                      <label>Tamanho máximo da imagem para envio: 10 mb.</label>
                      <label>Extensões de arquivos aceitos:
                        <span *ngIf="documento.code == 'PLANILHA_FUNCIONARIOS'">xls e xlsx</span>
                        <span *ngIf="documento.code != 'PLANILHA_FUNCIONARIOS'">png, jpg e pdf</span>.
                      </label>
                    </div>
                    <p *ngIf="documento.required">Obrigatório enviar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- documentos -->

    <wizard-step [title]="'Agendamento'" *ngIf="viewStep('Agendamento')" [isValid]="formlocal.form.valid"
      (onPrev)="voltar()" (onNext)="onStep6Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12" [ng2-loading]="showSpinner">
            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Agendamento</h2>
                </div>
              </header>
              <form class="row" #formlocal="ngForm">
                <div class="form-group col-lg-6">
                  <label for="locais">Local</label>

                  <select class="js-example-basic-single form-control" name="locais"
                    [(ngModel)]="model.serviceLocationId" id="locais" (ngModelChange)="alterarLocal(l)">
                    <option value="{{ local.id }}" *ngFor="let local of locais">{{ local.name }} - {{ local.address }}
                    </option>
                  </select>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': datas.invalid && datas.touched }">
                  <label for="datas">Data*</label>
                  <select class="js-example-basic-single form-control" #datas="ngModel" name="datas"
                    [(ngModel)]="dataSelecionada" id="datas" (ngModelChange)="getHora()" required>
                    <option *ngFor="let d of datasCustom" [value]="d.data">{{d.data}}
                    </option>
                  </select>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': horas.invalid && horas.touched }">
                  <label for="horas">Hora*</label>

                  <select class="js-example-basic-single form-control" #horas="ngModel" name="horas"
                    [(ngModel)]="horaSelecionada" id="horas" (ngModelChange)="getHora()" required>
                    <option *ngFor="let h of horasCustom" [value]="h.hora">{{h.hora}}
                    </option>
                  </select>
                  <label for="horas">Os horários disponíveis são exibidos de acordo com o dia selecionado.</label>
                  <label for="horas">Caso nenhum horário lhe atenda, favor alterar o dia no campo
                    <strong>DATA</strong>.</label>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- agendamento -->

    <wizard-step [title]="'Linhas mais usadas'" *ngIf="viewStep('Linhas mais usadas')"
      [isValid]="model.busServiceVOList && model.busServiceVOList.length > 0" (onPrev)="voltar()"
      (onNext)="onStep7Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10">

            <div class="form-panel form-panel-lg">

              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Linhas mais usadas</h2>
                  <p>Selecione até 4 linhas de ônibus que você mais utiliza no dia a dia.</p>
                </div>
              </header>

              <div class="my-4">
                <h3>Linhas Selecionadas</h3>
                <ul class="option-list">
                  <li *ngFor="let linha of model.busServiceVOList">
                    <button type="button" class="close" (click)="removerLinha(linha.id)"><span
                        aria-hidden="true">&times;</span></button>
                    <b style="color: black;">{{ linha.routeCode + " - " + linha.serviceMnemonic }}</b>
                  </li>
                  <li *ngIf="model.busServiceVOList.length == 0">
                    <h4>Nenhuma linha selecionada</h4>
                    <p class="caption">Selecione uma linha</p>
                  </li>
                </ul>
              </div>

              <div class="row justify-content-center" *ngIf="model.busServiceVOList.length < 4">
                <div class="col-lg-6">
                  <p class="btn btn-default btn-block" data-toggle="modal" data-target="#lines">Adicionar linha</p>
                </div>
              </div>
            </div>

            <div class="modal fade" id="lines" tabindex="-1" role="dialog" aria-labelledby="lines-Label"
              aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h2>Selecione uma linha</h2>
                    <button (click)="clearMessage()" id="fecharOutroModal" type="button" class="close"
                      data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <form>
                      <div class="form-group">
                        <div class="input-group mb-3">
                          <input type="text" [(ngModel)]="search" class="form-control" id="searchLinha"
                            name="searchLinha" placeholder="Número ou nome da linha"
                            aria-label="Número ou nome da linha" aria-describedby="basic-addon2">
                          <div class="input-group-append">
                            <button (click)="getLinhas()" class="btn btn-primary" type="button"><img alt="Pesquisar"
                                data-target="#result" src="assets/icons/lupa.svg">
                            </button>
                          </div>
                          <div class="col-sm-12 col-form-label col-form-label-sm text-danger">{{errorMessage}}</div>
                        </div>
                      </div>
                    </form>

                    <ul class="option-list" data-dismiss="modal" style="cursor: pointer;">
                      <li (click)="adicionarLinha(linha)" *ngFor="let linha of linhaOnibus">
                        <b style="color: black">{{ linha.routeCode + " - " + linha.serviceMnemonic }}</b>
                      </li>
                    </ul>
                    <div *ngIf="!linhaOnibus || linhaOnibus.length < 1">Não encontrado</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </wizard-step><!-- linhas mais usadas -->

    <wizard-step [title]="'Local retirada'" *ngIf="viewStep('Retirada')"
      [isValid]="(model.delivery == 'R' && model.serviceLocationId) || (model.delivery == 'E' && model.serviceShippingCostId && deliveryForm.form.valid)"
      (onPrev)="voltar()" (onNext)="onStep9Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">

            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Forma de Entrega</h2>
                </div>
              </header>


              <form class="row" name="form" #deliveryForm="ngForm">

                <div class="row col-lg-12">
                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.requireLocation">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" name="delivery" type="radio" value="R"
                        [(ngModel)]="model.delivery" name="delivery-radio" id="retira"
                        (ngModelChange)="carregaEntrega()">
                      <label class="form-check-label" for="retira">Retirar no Local</label>
                    </div>
                  </div>
                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.hasShipping">
                    <div class="form-check form-check-inline">
                      <input class="form-check-input" name="delivery" type="radio" value="E"
                        [(ngModel)]="model.delivery" name="delivery-radio" id="entrega"
                        (ngModelChange)="carregaEntrega()">
                      <label class="form-check-label" for="entrega">Entrega a domicilio</label>
                    </div>
                  </div>
                </div>

                <div class="row col-lg-12">
                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.requireLocation">
                    <label for="locaisRetirada">Local para retirada</label>

                    <select class="js-example-basic-single form-control" name="locaisRetirada"
                      [(ngModel)]="model.serviceLocationId" id="locaisRetirada" [disabled]="model.delivery == 'E'"
                      (ngModelChange)="alterarLocalRetirada($event)">
                      <option value=""></option>
                      <option value="{{ local.id }}" *ngFor="let local of locaisRetirada">{{ local.name }}</option>
                    </select>
                  </div>

                  <div class="form-group col-lg-6" *ngIf="dadosIniciaisAgendamento.servico.hasShipping">
                    <label for="fretes">Forma de envio</label>
                    <select class="js-example-basic-single form-control" name="fretes"
                      [(ngModel)]="model.serviceShippingCostId" id="fretes" [disabled]="model.delivery == 'R'"
                      (ngModelChange)="alterarFrete($event)">
                      <option value=""></option>
                      <option value="{{ frete.id }}" *ngFor="let frete of fretes">{{ frete.name }}</option>
                    </select>
                  </div>
                </div>

                <div class="form-group col-lg-12"
                  *ngIf="model.pagamento.additionalValue && model.pagamento.additionalValue > 0">
                  <strong>Valor a ser cobrado: {{ model.pagamento.additionalValue.toFixed(2) }} </strong>
                </div>

                <div class="form-group col-lg-12" *ngIf="model.delivery == 'R'">
                  <h3>Endereço do Local de Retirada</h3>
                  {{ model.serviceLocationAddress }}
                </div>

                <div class="form-group col-lg-12" *ngIf="model.delivery == 'E'">
                  <h3>Endereço de Entrega</h3>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': shippingCep.invalid && shippingCep.touched }"
                  *ngIf="model.delivery == 'E'">
                  <label>CEP*</label>
                  <input type="text" #shippingCep="ngModel" class="form-control" id="shippingCep" name="shippingCep"
                    [(ngModel)]="model.shippingInfo.cep" [textMask]="{mask: cepmask}"
                    (blur)="consultaCEP(shippingCep.value, model.shippingInfo)" placeholder="_____-___" required>
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': shippingAddress.invalid && shippingAddress.touched }"
                  *ngIf="model.delivery == 'E'">
                  <label>Nome da rua*</label>
                  <input type="text" #shippingAddress="ngModel" class="form-control" id="shippingAddress"
                    name="shippingAddress" [(ngModel)]="model.shippingInfo.address" placeholder="" required>
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': shippingAddressNumber.invalid && shippingAddressNumber.touched }"
                  *ngIf="model.delivery == 'E'">
                  <label>Número*</label>
                  <input type="text" #shippingAddressNumber="ngModel" class="form-control" id="shippingAddressNumber"
                    name="shippingAddressNumber" [(ngModel)]="model.shippingInfo.addressNumber" placeholder="" required>
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': shippingAddressComplement.invalid && shippingAddressComplement.touched }"
                  *ngIf="model.delivery == 'E'">
                  <label>Complemento</label>
                  <input type="text" #shippingAddressComplement="ngModel" class="form-control"
                    id="shippingAddressComplement" name="shippingAddressComplement"
                    [(ngModel)]="model.shippingInfo.addressComplement" placeholder="">
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': shippingNeighborhood.invalid && shippingNeighborhood.touched }"
                  *ngIf="model.delivery == 'E'">
                  <label>Bairro*</label>
                  <input type="text" #shippingNeighborhood="ngModel" class="form-control" id="shippingNeighborhood"
                    name="shippingNeighborhood" [(ngModel)]="model.shippingInfo.neighborhood" placeholder="" required>
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': shippingState.invalid && shippingState.touched }"
                  *ngIf="model.delivery == 'E'">
                  <label>Estado*</label>
                  <select class="js-example-basic-single form-control" #shippingState="ngModel"
                    [(ngModel)]="model.shippingInfo.state" id="shippingState" name="shippingState"
                    (ngModelChange)="atualizarCidades($event)" required>
                    <option value="AC">Acre (AC)</option>
                    <option value="AL">Alagoas (AL)</option>
                    <option value="AP">Amapá (AP)</option>
                    <option value="AM">Amazonas (AM)</option>
                    <option value="BA">Bahia (BA)</option>
                    <option value="CE">Ceará (CE)</option>
                    <option value="DF">Distrito Federal (DF)</option>
                    <option value="ES">Espírito Santo (ES)</option>
                    <option value="GO">Goiás (GO)</option>
                    <option value="MA">Maranhão (MA)</option>
                    <option value="MT">Mato Grosso (MT)</option>
                    <option value="MS">Mato Grosso do Sul (MS)</option>
                    <option value="MG">Minas Gerais (MG)</option>
                    <option value="PA">Pará (PA)</option>
                    <option value="PB">Paraíba (PB)</option>
                    <option value="PR">Paraná (PR)</option>
                    <option value="PE">Pernambuco (PE)</option>
                    <option value="PI">Piauí (PI)</option>
                    <option value="RJ">Rio de Janeiro (RJ)</option>
                    <option value="RN">Rio Grande do Norte (RN)</option>
                    <option value="RS">Rio Grande do Sul (RS)</option>
                    <option value="RO">Rondônia (RO)</option>
                    <option value="RR">Roraima (RR)</option>
                    <option value="SC">Santa Catarina (SC)</option>
                    <option value="SP">São Paulo (SP)</option>
                    <option value="SE">Sergipe (SE)</option>
                    <option value="TO">Tocantins (TO)</option>
                  </select>
                </div>

                <div class="form-group col-lg-6" *ngIf="model.delivery == 'E'">
                  <label>Cidade</label>
                  <select class="js-example-basic-single form-control" #shippingCity="ngModel" name="shippingCity"
                    [(ngModel)]="model.shippingInfo.city">
                    <option *ngFor="let d of cidades" [value]="d.nome" [selected]="d.nome === model.shippingInfo.city">
                      {{d.nome}}
                    </option>
                  </select>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- local para retirada -->

    <wizard-step [title]="'Pagamento'" *ngIf="viewStep('Pagamento')" [isValid]="form4.form.valid" (onPrev)="voltar()"
      (onNext)="onStep10Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12">
            <div class="form-panel form-panel-lg">
              <header class="row">
                <div class="col">
                  <h2>{{ cursor + 1 }}. Pagamento</h2>
                </div>
              </header>

              <form id="formPagamento" class="row" name="formPagamento" #form4="ngForm">

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cpfCard.invalid && cpfCard.touched }">
                  <label>CPF do portador do cartão de crédito</label>
                  <input type="text" #cpfCard="ngModel" class="form-control" id="cpfCard" name="cpfCard"
                    [(ngModel)]="model.pagamento.cardholdercpf" [textMask]="{mask: cpfmask}"
                    placeholder="___.___.___-__" (ngModelChange)="isCardCpfValid($event)">
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': nameCard.invalid && nameCard.touched }">
                  <label>Nome no cartão de crédito*</label>
                  <input type="text" #nameCard="ngModel" class="form-control" id="nameCard" name="nameCard"
                    [(ngModel)]="model.pagamento.cardholdername" required>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cardNumber.invalid && cardNumber.touched }">
                  <label>Número do cartão {{ ( cardFlagName ) ? '(' + cardFlagName + ')' : null }}*</label>
                  <input type="text" #cardNumber="ngModel" class="form-control clean-ui" id="cardNumber"
                    name="cardNumber" [(ngModel)]="model.pagamento.cardnumber" (ngModelChange)="checkCardFlag($event)"
                    pattern="[0-9]{13,16}" required>
                  <div *ngIf="cardNumber.errors && cardNumber.invalid && cardNumber.dirty">
                    <small class="text-danger" *ngIf="cardNumber.errors.required">Necessário informar número do cartão
                      de crédito</small>
                    <small class="text-danger" *ngIf="cardNumber.errors.pattern">Número de cartão de crédito inválido,
                      13 a 16 dígitos, sem espaço</small>
                  </div>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': cvv.invalid && cvv.touched }">
                  <label>CVV do cartão de crédito*</label>
                  <input type="text" #cvv="ngModel" class="form-control clean-ui" id="cvv" name="cvv"
                    [(ngModel)]="model.pagamento.cvv" pattern="[0-9]{3,4}" required>
                  <div *ngIf="cvv.errors && cvv.invalid && cvv.dirty">
                    <small class="text-danger" *ngIf="cvv.errors.required">Necessário informar código de segurança do
                      cartão de crédito</small>
                    <small class="text-danger" *ngIf="cvv.errors.pattern">Código de segurança inválido, 3 a 4
                      dígitos</small>
                  </div>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': expiremonth.invalid && expiremonth.touched }">
                  <label>Mês do vencimento do cartão de crédito*</label>
                  <select class="js-example-basic-single form-control" #expiremonth="ngModel"
                    [(ngModel)]="model.pagamento.expiremonth" id="expiremonth" name="expiremonth"
                    (ngModelChange)="checkExpireDate()" required>
                    <option value="01">01</option>
                    <option value="02">02</option>
                    <option value="03">03</option>
                    <option value="04">04</option>
                    <option value="05">05</option>
                    <option value="06">06</option>
                    <option value="07">07</option>
                    <option value="08">08</option>
                    <option value="09">09</option>
                    <option value="10">10</option>
                    <option value="11">11</option>
                    <option value="12">12</option>
                  </select>
                  <div *ngIf="expiremonth.errors && expiremonth.invalid && expiremonth.dirty">
                    <small class="text-danger" *ngIf="cvv.errors.incorrect">Cartão com data de validade expirada</small>
                  </div>
                </div>

                <div class="form-group col-lg-6" [ngClass]="{ 'invalid': expireyear.invalid && expireyear.touched }">
                  <label>Ano do vencimento do cartão de crédito*</label>
                  <input type="number" #expireyear="ngModel" class="form-control clean-ui" id="expireyear"
                    name="expireyear" [(ngModel)]="model.pagamento.expireyear" placeholder="20XX" min="2020" max="9999"
                    (ngModelChange)="checkExpireDate()" required>
                  <div *ngIf="expireyear.errors && expireyear.invalid && expireyear.dirty">
                    <small class="text-danger" *ngIf="cvv.errors.incorrect">Cartão com data de validade expirada</small>
                  </div>
                </div>

                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': valueToPayFormatted.invalid && valueToPayFormatted.touched }">
                  <label>Valor do serviço (R$)</label>
                  <input type="text" #valueToPayFormatted="ngModel" class="form-control" id="valueToPayFormatted"
                    name="valueToPayFormatted" [(ngModel)]="dadosIniciaisAgendamento.servico.valueToPayFormatted"
                    disabled>
                </div>
                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': shippingFeeFormatted.invalid && shippingFeeFormatted.touched }">
                  <label>Valor do frete (R$)</label>
                  <input type="text" #shippingFeeFormatted="ngModel" class="form-control" id="shippingFeeFormatted"
                    name="shippingFeeFormatted" [(ngModel)]="dadosIniciaisAgendamento.servico.shippingFeeFormatted"
                    disabled>
                </div>
                <div class="form-group col-lg-6"
                  [ngClass]="{ 'invalid': shippingFeeFormatted.invalid && shippingFeeFormatted.touched }">
                  <label>Valor Total (R$)</label>
                  <input type="text" #totalValueFormatted="ngModel" class="form-control" id="totalValueFormatted"
                    name="totalValueFormatted" [(ngModel)]="dadosIniciaisAgendamento.servico.totalValueFormatted"
                    disabled>
                </div>
              </form>

            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- pagamento -->

    <wizard-step [title]="'Resumo'" *ngIf="viewStep('Pagamento')" (onPrev)="voltar()" (onNext)="onStep11Next($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="form-panel form-panel-lg col-12 col-lg-12">
            <header class="row">
              <div class="col">
                <h2>Confirmação dos dados</h2>
                <p>Por favor confira os dados que foram preenchidos.</p>
              </div>
            </header>

            <div class="row infos">
              <dl class="row caption mt-4 col-md-6" *ngIf="viewStep('Informações pessoais')">
                <dt class="col-4">Cartão/Serviço:</dt>
                <dd class="col-8">{{ dadosIniciaisAgendamento.servico.serviceName }}</dd>
                <dt class="col-4">Nome Completo:</dt>
                <dd class="col-8">{{ model.userData.fullName }}</dd>
                <dt class="col-4">Nome da mãe:</dt>
                <dd class="col-8">{{ model.userData.motherFullName }}</dd>
                <dt class="col-4">Nome do pai:</dt>
                <dd class="col-8">{{ model.userData.fatherFullName }}</dd>
                <dt class="col-4">E-mail:</dt>
                <dd class="col-8">{{ model.userData.email }}</dd>
                <dt class="col-4">CPF:</dt>
                <dd class="col-8">{{ model.userData.cpf | docFormat: 'cpf' }}</dd>
              </dl>

              <dl class="row caption mt-4 col-md-6" *ngIf="viewStep('Endereço')">
                <dt class="col-4">Endereço:</dt>
                <dd class="col-8">{{ model.userData | addressFormat: 'full' }}</dd>
                <dt class="col-4">CEP:</dt>
                <dd class="col-8">{{ model.userData.cep }}</dd>
                <dt class="col-4">Bairro:</dt>
                <dd class="col-8">{{ model.userData.neighborhood }}</dd>
                <dt class="col-4">Estado:</dt>
                <dd class="col-8">{{ model.userData.state }}</dd>
                <dt class="col-4">Cidade:</dt>
                <dd class="col-8">{{ model.userData.city }}</dd>
              </dl>

              <dl class="row caption mt-4 col-md-6" *ngIf="viewStep('Instituição de ensino') || viewStep('Curso')">
                <dt *ngIf="viewStep('Instituição de ensino')" class="col-4">Instituição:</dt>
                <dd *ngIf="viewStep('Instituição de ensino')" class="col-8">{{ model.institutionData ?
                  model.institutionData.name : "Sem instituição" }}</dd>
                <dt *ngIf="viewStep('Curso')" class="col-4">Tipo de Curso:</dt>
                <dd *ngIf="viewStep('Curso')" class="col-8">{{ model.institutionData.institutionCourseType }}</dd>
                <dt *ngIf="viewStep('Curso')" class="col-4">Período:</dt>
                <dd *ngIf="viewStep('Curso')" class="col-8">{{ model.institutionData.institutionCoursePeriod }}</dd>
                <dt *ngIf="viewStep('Curso')" class="col-4">Nome do curso:</dt>
                <dd *ngIf="viewStep('Curso')" class="col-8">{{ model.institutionData.institutionCourseName }}</dd>
                <dt *ngIf="viewStep('Curso')" class="col-4">Matrícula:</dt>
                <dd *ngIf="viewStep('Curso')" class="col-8">{{ model.institutionData.institutionEnrollmentId }}</dd>
                <dt *ngIf="viewStep('Curso')" class="col-4">Semestre:</dt>
                <dd *ngIf="viewStep('Curso')" class="col-8">{{ model.institutionData.institutionCourseYear }}</dd>
                <dt *ngIf="viewStep('Curso')" class="col-4">Duração:</dt>
                <dd *ngIf="viewStep('Curso')" class="col-8">{{ model.institutionData.institutionCourseDuration }}</dd>
                <dt *ngIf="viewStep('Curso')" class="col-4">Ano de conclusão:</dt>
                <dd *ngIf="viewStep('Curso')" class="col-8">{{ model.institutionData.institutionCourseEndYear }}</dd>
              </dl>

              <dl class="row caption mt-4 col-md-6" *ngIf="viewStep('Agendamento')">
                <dt class="col-4">Local:</dt>
                <dd class="col-8">{{ model.serviceLocation }}</dd>
                <dt class="col-4">Data:</dt>
                <dd class="col-8">{{ model.selectedDate |date: 'dd/MM/yyyy' }}</dd>
                <dt class="col-4">Hora:</dt>
                <dd class="col-8">{{ model.selectedDate |date: 'HH:mm' }}</dd>
              </dl>

              <dl class="row caption mt-4 col-md-6" *ngIf="viewStep('Retirada') && model.delivery == 'R'">
                <dt class="col-12">Retirar no Local:</dt>
                <dt class="col-4">Local:</dt>
                <dd class="col-8">{{ model.serviceLocation }}</dd>
                <dt class="col-4">Endereço:</dt>
                <dd class="col-8">{{ model.serviceLocationAddress }}</dd>
              </dl>
              <dl class="row caption mt-4 col-md-6" *ngIf="viewStep('Retirada') && model.delivery == 'E'">
                <dt class="col-12">Entregar no endereço:</dt>
                <dt class="col-4">Endereço:</dt>
                <dd class="col-8">{{ model.shippingInfo.address }}, {{ model.shippingInfo.addressNumber}} {{
                  model.shippingInfo.addressComplement }}</dd>
                <dt class="col-4">CEP:</dt>
                <dd class="col-8">{{ model.shippingInfo.cep }}</dd>
                <dt class="col-4">Bairro:</dt>
                <dd class="col-8">{{ model.shippingInfo.neighborhood }}</dd>
                <dt class="col-4">Estado:</dt>
                <dd class="col-8">{{ model.shippingInfo.state }}</dd>
                <dt class="col-4">Cidade:</dt>
                <dd class="col-8">{{ model.shippingInfo.city }}</dd>
              </dl>

              <dl class="row caption mt-4 col-md-6" *ngIf="viewStep('Linhas mais usadas')">
                <dt class="col-12">Linhas mais usadas</dt>
                <dd class="col-3" *ngFor="let linha of model.busServiceVOList">
                  {{ linha.routeCode + " - " + linha.serviceMnemonic }}
                <dd>
                <dd *ngIf="model.busServiceVOList.length == 0">Nenhuma linha selecionada</dd>
              </dl>

              <dl class="row caption mt-4 col-md-6" *ngIf="viewStep('Pagamento')">
                <dt class="col-6">CPF portador do cartão de crédito:</dt>
                <dd class="col-6">{{ model.pagamento.cardholdercpf | docFormat: 'cpf' }}</dd>
                <dt class="col-6">Nome no cartão de crédito:</dt>
                <dd class="col-6">{{ model.pagamento.cardholdername }}</dd>
                <dt class="col-6">Número do cartão:</dt>
                <dd class="col-6">{{ model.pagamento.cardnumber | cardnumberFormat }}</dd>
                <dt class="col-6">Vencimento do cartão:</dt>
                <dd class="col-6">{{ model.pagamento.expiremonth + "/" + model.pagamento.expireyear }}</dd>
                <dt class="col-6">Valor Total:</dt>
                <dd class="col-6">{{ dadosIniciaisAgendamento.servico.totalValue | currency: 'BRL' }}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </wizard-step><!-- resumo -->

    <wizard-step [title]="'Concluído'" [isValid]="resultado" (onComplete)="onComplete($event)">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-12" [ng2-loading]="showSpinner">

            <div class="form-panel form-panel-lg" *ngIf="concluido">
              <header class="row">
                <div class="col">
                  <h2>Atendimento Concluído</h2>
                  <p>Agradecemos a sua participação e informamos que o protocolo de atendimento foi gerado com sucesso.
                  </p>
                </div>
              </header>

              <div class="caption mt-2">
                <h3>Protocolo #{{ resultado ? resultado.protocol : '' }} </h3>

                <div class="caption mb-4">
                  <p>Criado em {{ currentDate | date: 'dd/MM/yyyy HH:mm:ss' }}.</p>
                </div>

                <div class="caption mb-2 text-success"
                  *ngIf="dadosIniciaisAgendamento.servico.hasPayment && resultado.statusPagamento === 'AUTORIZADO'">
                  <p>Pagamento <strong>{{ resultado.statusPagamento }}</strong></p>
                </div>
                <div class="caption mb-2 text-danger"
                  *ngIf="dadosIniciaisAgendamento.servico.hasPayment && resultado.statusPagamento === 'NÃO AUTORIZADO'">
                  <p>Pagamento <strong>{{ resultado.statusPagamento }}</strong></p>
                </div>

                <div class="caption mb-2">
                  <div>
                    <span>{{ model.serviceTypeVO.description }}</span>
                  </div>
                  <div>
                    <span>{{ model.serviceName }}</span>
                  </div>
                </div>
                <div class="caption mb-2" *ngIf="model.appointment">
                  <div>
                    <span *ngIf="model.serviceLocation">Local: {{ model.serviceLocation }} - {{
                      model.serviceLocationAddress }}</span>
                  </div>
                  <div *ngIf="model.selectedDate">
                    <span>Data de Agendamento: {{ model.selectedDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-03:00' }}</span>
                  </div>
                </div>
                <div class="caption mb-2" *ngIf="!model.appointment">
                  <div *ngIf="model.selectedDate">
                    <span>Data da Solicitação: {{ model.selectedDate | date: 'dd/MM/yyyy HH:mm' : 'UTC-03:00' }}</span>
                  </div>
                  <div *ngIf="model.delivery == 'R'">
                    <span>Local de Retirada: {{ model.serviceLocation }} - {{ model.serviceLocationAddress }}</span>
                  </div>
                  <div *ngIf="model.delivery == 'E'">
                    <span>Endereço de Entrega: {{ model.shippingInfo.address }}, {{ model.shippingInfo.addressNumber}}
                      {{ model.shippingInfo.addressComplement }}, {{ model.shippingInfo.neighborhood }}, {{
                      model.shippingInfo.city }}, {{ model.shippingInfo.state }}</span>
                  </div>
                </div>
                <div class="caption mb-2">
                  <div class="font-weight-bold">Estas informações serão enviadas no seu e-mail cadastrado. Verifique a
                    pasta de spam caso não esteja na Caixa de Entrada.</div>
                </div>
              </div>
            </div>

            <div class="form-panel form-panel-lg" *ngIf="erro">
              <div>
                <h3>{{ resultado && resultado.message ? resultado.message : 'Erro' }} </h3>

              </div>
            </div>

            <div class="form-panel form-panel-lg" *ngIf="!resultado">
              <header class="row">
                <div class="col">
                  <h2>Aguarde, processando...</h2>
                </div>
              </header>
            </div>
          </div>
        </div>
      </div>

    </wizard-step><!-- atendimento concluido -->
  </form-wizard>
</div>
<footer id="main-cta">
  <div class="summary">
    <p>{{ this.etapas ? (this.etapas[cursor] != undefined ? this.etapas[cursor].title : '') : '' }}</p>
    <p class="small">Etapa {{ cursor + 1 }} de {{ this.etapas ? this.etapas.length : 0 }}</p>
    <ul class="summary-bullets">
      <li [ngClass]="{'active': cursor == i}" *ngFor="let etapa of etapas; let i = index"></li>
    </ul>
  </div>
</footer>